<h2>Aanmelden voor {{eventName}}</h2>
<form bijbForm (bijbSubmit)="signup()" novalidate>
  <table>
    <tr>
      <td colspan="2"><i>De voor- en achternaam worden getoond in de app.</i></td>
    </tr>
    <tr>
      <td class="align-right">Voornaam</td>
      <td class="align-left">
        <app-form-input-errors [input]="firstName"></app-form-input-errors>
        <input name="voornaam" type="text" [(ngModel)]="credentials.firstName" required pattern=".*\S+.*" trim="blur"
               #firstName="ngModel" /></td>
    </tr>
    <tr>
      <td class="align-right">Achternaam</td>
      <td class="align-left">
        <app-form-input-errors [input]="lastName"></app-form-input-errors>
        <input name="achternaam" type="text" [(ngModel)]="credentials.lastName" required pattern=".*\S+.*"
        trim="blur" #lastName="ngModel" />
      </td>
    </tr>
    <tr>
      <td class="align-right">Emailadres</td>
      <td class="align-left">
        <app-form-input-errors [input]="emailAddress"></app-form-input-errors>
        <input name="email" type="email" [(ngModel)]="credentials.emailAddress" email required pattern=".*\S+.*"
               #emailAddress="ngModel" trim="blur" /></td>
    </tr>
    <tr>
      <td class="align-right">Wachtwoord</td>
      <td class="align-left">
        <app-form-input-errors [input]="password"></app-form-input-errors>
        <input name="password" type="password" [(ngModel)]="credentials.password" [minlength]="8" required
               #password="ngModel" />
      </td>
    </tr>
  </table>

  <app-form-buttons [resetButtonEnabled]="false"
                    [saveCaption]="'aanmelden'"
                    [updateButtonState]="false"
                    [errorMessage]="error"
                    [busy]="busy"></app-form-buttons>
</form>
